<script setup lang="ts">
import { DropdownMenuContent, DropdownMenuPortal } from 'reka-ui';

withDefaults(
    defineProps<{
        side?: 'top' | 'right' | 'bottom' | 'left';
        sideOffset?: number;
        align?: 'start' | 'center' | 'end';
    }>(),
    {
        side: 'bottom',
        sideOffset: 5,
        align: 'end',
    },
);
</script>

<template>
    <DropdownMenuPortal>
        <DropdownMenuContent
            :side="side"
            :side-offset="sideOffset"
            :align="align"
            class="z-[100] min-w-[8rem] overflow-y-auto rounded-lg border bg-white p-1 shadow-muval-3 outline-none data-[state=closed]:animate-dropdownOut data-[state=open]:animate-dropdownIn"
        >
            <slot />
        </DropdownMenuContent>
    </DropdownMenuPortal>
</template>
